module.exports = __webpack_public_path__ + "files/e2dab5154257306233fd719cbc7bf47d.png";